type KeyString = {
  [key: string]: string
}

export function getFrequenciesActivitiesTypesNamesFilterFeedbacks(value: any) {
  const arrayValue = Array.isArray(value) ? value.join(', ') : []

  const frequenciesActivitiesTypesNamesFilterTagsFeedbacks: KeyString = {
    has_activities_types: `Possuem estes tipos de atividades: ${arrayValue}`,
    not_has_activities_types: `Não possuem estes tipos de atividades: ${arrayValue}`,
  }

  return frequenciesActivitiesTypesNamesFilterTagsFeedbacks
}
